import React from 'react';
import PropTypes from 'prop-types';
import './form-field.css';

const FormLabel = (props) => (
  <label htmlFor={props.id} className="form-group-label">
    {props.label}
    {props.required ? '*' : null}
  </label>
);

const FormGroup = (props) => (
  <div className="form-group">
    {props.label ? <FormLabel {...props} /> : null}
    <div>{props.children}</div>
  </div>
);

FormLabel.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
};

FormGroup.propTypes = {
  ...FormLabel.propTypes,
  children: PropTypes.node.isRequired,
};

export default FormGroup;
